import { useNavigate} from "react-router-dom"
import styled from "styled-components";
import {AiOutlineSearch} from "react-icons/ai"
import { useState } from "react";

const Search = () => {

    const[input, setInput]= useState('')
    const navigate = useNavigate();

    const submitHandler =(e) => {
        e.preventDefault();
        navigate("/searched/" +input)
    }

  return (
    <FormStyle onSubmit={submitHandler}>
        <div>
            <AiOutlineSearch/>
            <input onChange={(e) =>setInput(e.target.value)} type="text" value={input}/>
        </div>
    </FormStyle>
  )
}

const FormStyle = styled.form`
    margin: 1rem 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    input{
        background: linear-gradient(to right, #313131, #343131);
        padding  :10px 100px ;
        border-radius: 2rem;
        color: white;
        
    }
    svg{
        position: absolute;
        font-size: 1.5rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.7rem;
    }
    @media only screen and (max-width: 390px) {
       margin: auto 6rem;

  }
`


export default Search